import gql from 'graphql-tag'  //引入graphql
const apollo={
	todo:gql`query tasks($cate: String!,$userId:String){
		tasks(cate:$cate,userId:$userId){
			name,
			id,
			assignTime,
			uri,
			actionName,
			process{
				id,
				name,
				uri,
				tags,
				entry,
				owner{
					id,
					name,
					account
				}
				app{
					name
				}
				system{
					name
				}
			}
		}
	}`,
	process:gql`query process($id:String,$entry:String,$system:String){
		process(id:$id,entry:$entry,system:$system){
			id
			name
			uri
			entry
			status
			create
			update
			priority
			tags
			rating
			review
			pendingTasks
			app {
			  id
			  code
			  name
			  uri
			  tags
			  icon
			  department
			  abbreviation
			  description
			  recommend
			  palette
			  rating
			  rated
			  system
			}
			owner {
			  id
			  account
			  name
			}
			system{
			  id
			  name
			}
		  tasks{
			id
			name
			actionUser{
				name
			}
			actionTime
			actionName
		  }
			
		}
	}`,
	doing:gql`query processes($cate:String!,$userId:String,$page:Int,$size:Int,$keyword:String,$sep:Boolean){
		processes(cate:$cate,userId:$userId,page:$page,size:$size,keyword:$keyword,sep:$sep){
			total,
			processes{
				id,
			    name,
			    uri,
			    entry,
			    pendingTasks,
			    update,
			    app{
			    	name
			    }
				system{
					name
				}
			}
		}
	}`,
	done:gql`query processes($cate:String!,$userId:String,$page:Int,$size:Int,$keyword:String,$sep:Boolean){
		processes(cate:$cate,userId:$userId,page:$page,size:$size,keyword:$keyword,sep:$sep){
			total,
			processes{
				id,
			    name,
			    uri,
			    entry,
			    pendingTasks,
			    update,
			    app{
			    	name
			    }
				system{
					name
				}
			}
		}
	}`,
	guide:gql`query guide($first: Int,$offset: Int,$id: ID,$title: String,$stepTitle: String,$context: String,$keyword: String
	,$isRealease: Boolean,$state: Int,$appId: [String],$appTag: String,$appName: String,$appCode: [String]){
	    guide(first:$first,offset:$offset,id:$id,title:$title,stepTitle:$stepTitle,context:$context,keyword:$keyword
	,isRealease:$isRealease,state:$state,appId:$appId,appTag:$appTag,appName:$appName,appCode:$appCode){
	    totalCount
	    edges{
	      node{
	        id
	        title
	  		keyword
	  		mainpic
	  		isRealease
	 	 	createUser
	  		createUserAccount
	 	 	createTime
	  		updateTime
	  		updateUser
	  		updateUserAccount
	  		state
	  		guideStepList{
	          listId
	          context
	          guideId
	          stepNo
	          stepTitle
	          guideStepAppList{
	            listAppId
	            appId
	            appCode
	            appName
	            appTag
	            appUrl
	            guideId
	            guideStepId
	          }
	        }
	      }
	    }
	  }
	}`,
	getPosts: gql`query getPosts($id: ID $first: Int $last: Int $before: String $after: String $offset: Int $filter: Filter $keywords: String $tags: String) {
        posts(id: $id first: $first last: $last before: $before after: $after offset: $offset filter: $filter keywords: $keywords tags: $tags) {
          edges {
            node {
              id
            }
          }
        }
  	}`,

	// 获取登录人信息 (iam)
    me: gql`query me {
  me {
    id
    name
    username
    cardNo
    phone
    email
    openid
    tenant {
      id
      name
      domain
      code
    }
    positions {
      tags
      id
      index
      code
      startTime
      active
      endTime
      cardType
      cardNo
      description
      createTime
      source
      dataSource
      timestamp
      validStartTime
      validEndTime
      createSource
      createDataSource
      positionAttrsValues: attrsValues {
        key
        value
      }
      dept {
        id
        name
        code
        active
        revocation
        ancestor {
          name
          code
        }
      }
      post {
        id
        name
        code
        active
        postType
        ancestor {
          name
          code
        }
      }
    }
  }
}
`,

	postTypes: gql`query postTypes($filter: PostTypeFilter) {
  postTypes(filter: $filter) {
    id
    code
    name
    createTime
    createUser
    description
    typeIndex
  }
}
`,


}
export default apollo


// WEBPACK FOOTER //
// ./src/graphql/apollo.js